import React from 'react';
import { SvgIcon } from '@mui/material';

function EditBlueIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M18.41 5.79988L17.2 4.58988C16.42 3.80988 15.15 3.80988 14.37 4.58988L11.69 7.26988L3 15.9599V19.9999H7.04L15.78 11.2599L18.41 8.62988C19.2 7.84988 19.2 6.57988 18.41 5.79988ZM6.21 17.9999H5V16.7899L13.66 8.12988L14.87 9.33988L6.21 17.9999ZM11 19.9999L15 15.9999H21V19.9999H11Z"
        fill="#656985"
      />
    </SvgIcon>
  );
}

export default EditBlueIcon;
